import React from 'react';
import { motion } from 'framer-motion';
import '../styles/BenefitsBlock.css';

const BenefitsBlock = () => {
  const benefits = [
    {
      icon: '⚙️',
      title: 'Qué son las Estrategias Mecánicas Inteligentes',
      description: 'El framework que diferencia a los profesionales del retail.',
    },
    {
      icon: '📊',
      title: '3 Estrategias Reales de Gestor de Fondos',
      description: 'No versiones educativas, ejecución real. Las mismas que uso operando.',
    },
    {
      icon: '🎯',
      title: 'Detección de liquidez',
      description: 'Dónde pierde el retail y cómo evitarlo.',
    },
    {
      icon: '🔴',
      title: 'Operativa en vivo',
      description: 'Verás ejecutar a un gestor de fondos en tiempo real.',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  return (
    <motion.div
      className="benefits-grid"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {benefits.map((benefit, index) => (
        <motion.div
          key={index}
          className="benefit-card"
          variants={cardVariants}
          whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(255, 100, 0, 0.2)' }}
        >
          <div className="benefit-icon">{benefit.icon}</div>
          <h3 className="benefit-title">{benefit.title}</h3>
          <p className="benefit-description">{benefit.description}</p>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default BenefitsBlock;
